import service from "@/utils/request";
//学员列表
export interface courseListDatas {
  page: number;
  page_size: number;
  key_word?: string;
  status?: number;
  student_id?: number;
  course_id?: number;
  expire_status?: number[];
  teacher_id?: number;
  stop_status?: number[];
  completion_status?: number;
  follow_staff_id?: number;
  usable_number_start?: string;
  usable_number_end?: string;
  [propName: string]: any;
}
// 搜索列表
export interface autoSearchData {
  page: number;
  page_size: number;
  key_word?: String;
  name?: String;
  course_name?: String;
  mobile?: String;
}
// 学员列表
export const courseListData = (data: courseListDatas) => {
  return service({
    url: "/api/v1/student/course/all_list",
    method: "post",
    data,
  });
};
// 学员搜索列表
export const searchStudent = (data: courseListDatas) => {
  return service({
    url: "/api/v1/student/select_list",
    method: "post",
    data,
  });
};

// 教师搜索列表
export const geteacherList = (params: autoSearchData) => {
  return service({
    url: "/api/v1/teacher/list",
    method: "get",
    params,
  });
};

// 教师搜索列表
export const getcourseList = (params: autoSearchData) => {
  return service({
    url: "/api/v1/course/list",
    method: "get",
    params,
  });
};
// 结课
export const getcourseFinish = (data: {
  account_id: number;
  force?: number;
}) => {
  return service({
    url: "/api/v1/student/course/finish",
    method: "post",
    data,
  });
};
// 停课
export const getcourseFreeze = (data: {
  account_id: number;
  start_time: number;
  end_time: number;
}) => {
  return service({
    url: "/api/v1/student/course/freeze",
    method: "post",
    data,
  });
};
// 复课
export const getcourseUnfreeze = (data: {
  stop_id: number;
  end_time: number;
}) => {
  return service({
    url: "/api/v1/student/course/unfreeze",
    method: "post",
    data,
  });
};
// 停课记录
export const getfreezerecord = (params: { account_id: number }) => {
  return service({
    url: "/api/v1/student/course/get_freeze_record",
    method: "get",
    params,
  });
};
//导出列表
export interface exportData {
  student_id?: number;
  course_id?: number;
  expire_status?: number[];
  teacher_id?: number;
  stop_status?: number[];
  completion_status?: number;
  follow_staff_id?: number;
  usable_number_start?: string;
  usable_number_end?: string;
  is_exceed?: any;
  subject_id?: number;
  student_status?: number;
  relation_teacher_id?: number;
}
//导出
export const exportStudentcourse = (data: exportData) => {
  return service({
    url: "/api/v1/student/course/all_list/export",
    method: "post",
    data,
  });
};

//导出
export const studentCourseCountApi = (data: courseListDatas) => {
  return service({
    url: "/api/v1/student/course/count",
    method: "post",
    data,
  });
};
